parseOperationTypeDefinition